/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetModel } from '../../models/patient-target-model';
import { PatientTargetPropagateModel } from '../../models/patient-target-propagate-model';

export interface SavePatientTarget$Params {
      body?: PatientTargetPropagateModel
}

export function SavePatientTarget(http: HttpClient, rootUrl: string, params?: SavePatientTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientTarget.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientTargetModel>;
    })
  );
}

SavePatientTarget.PATH = '/api/Supervisor/SavePatientTarget';
